import { useEffect, useState } from 'react'

import AddressSummaryDisplay from 'checkout/components/ShippingAddressPanel/AddressSummaryDisplay'
import CheckoutPanel from 'checkout/components/CheckoutPanel'
import { AddressFormContextProvider } from 'checkout/containers/AddressFormContextProvider'
import { CheckoutQA } from 'shared/dataAttributes'
import { GuestShippingAddressForm } from 'checkout/panels/ShippingAddress/GuestShippingAddressForm'
import { NewShippingAddressForm } from 'checkout/panels/ShippingAddress/NewShippingAddressForm'
import { SavedShippingAddressForm } from 'checkout/panels/ShippingAddress/SavedShippingAddressForm'
import { setShippingAddress } from 'store/checkoutSlice'
import { t } from 'localization'
import { useAppDispatch } from 'store/hooks'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'
import { useGetAddressQuery } from 'api/addressesApi'
import { useShoppingRegionContext } from 'shared/contexts/ShoppingRegionContextProvider'

const TP = 'checkout.panels.ShippingAddress.ShippingAddressPanel'

export const ShippingAddressPanel = () => {
  const {
    order,
    panels: { shippingAddress },
  } = useCheckoutContext()
  const dispatch = useAppDispatch()

  const getExpandedContent = () => {
    switch (shippingAddress.view) {
      case 'guest':
        return <GuestShippingAddressForm />
      case 'new':
        return <NewShippingAddressForm />
      case 'saved':
        return <SavedShippingAddressForm />
    }
  }

  const { setIsOrderPriceUpdated } = useShoppingRegionContext()
  const [skip, setSkip] = useState(true)
  const [prevCurrencyCode, setPrevCurrencyCode] = useState<string>()
  const [prevIsInstantShip, setPrevIsInstantShip] = useState(order?.isInstantShip)
  const [prevPrice, setPrevPrice] = useState<number>()
  const price = order?.localizedPriceCents?.amount || 0
  const currency = order?.localizedPriceCents?.currency

  const { data, isLoading, isSuccess } = useGetAddressQuery(order?.addressId, {
    skip,
  })

  useEffect(() => {
    if (price) {
      if (
        price !== prevPrice &&
        prevPrice &&
        prevIsInstantShip === order?.isInstantShip &&
        currency === prevCurrencyCode
      ) {
        setIsOrderPriceUpdated(true)
      }
      setPrevCurrencyCode(currency)
      setPrevIsInstantShip(order?.isInstantShip)
      setPrevPrice(price)
    }
  }, [currency, price, order?.isInstantShip])

  useEffect(() => {
    if (order?.addressId) {
      setSkip(false)
    }
  }, [order?.addressId])

  useEffect(() => {
    if (isSuccess) {
      dispatch(setShippingAddress(data))
    }
  }, [data, isSuccess])

  return (
    <AddressFormContextProvider>
      <CheckoutPanel
        title={t(`${TP}.shippingAddress`, 'Shipping Address')}
        name="shippingAddress"
        qaAttr={CheckoutQA.ShippingAddress}
        expandedContent={getExpandedContent()}
        summarizedContent={
          isLoading ? null : <AddressSummaryDisplay qaAttr="ShippingAddress" {...data} />
        }
      />
    </AddressFormContextProvider>
  )
}
